import { surfaceIncludes } from './app-surface';

export function productModuleEnabled(value: string | undefined, development: boolean): boolean {
  return value === undefined ? development : value === 'true';
}

export const appBenchModuleEnabled =
  productModuleEnabled(import.meta.env.VITE_APPBENCH_MODULE_ENABLED, import.meta.env.DEV) &&
  surfaceIncludes('appbench');

export const schedulingModuleEnabled =
  import.meta.env.VITE_SCHEDULING_MODULE_ENABLED === 'true' && surfaceIncludes('study_scheduling');

/** Recruiters and schedulers only work in Study Scheduling; they never take part in data collection. */
export const SCHEDULING_STAFF_ROLES = ['recruiter', 'scheduler'] as const;

export function isSchedulingStaff(user: { role?: string } | null | undefined): boolean {
  return (SCHEDULING_STAFF_ROLES as readonly string[]).includes(user?.role || '');
}

export function canAccessScheduling(
  user: { role?: string; products?: { study_scheduling?: boolean } } | null | undefined,
  enabled = schedulingModuleEnabled,
): boolean {
  if (!enabled || !user) return false;
  if (user.role === 'super_admin') return true;
  return ['admin', 'project_manager', 'recruiter', 'scheduler'].includes(user.role || '')
    && user.products?.study_scheduling === true;
}

export const physicalAiModuleEnabled =
  import.meta.env.VITE_PHYSICAL_AI_MODULE_ENABLED === 'true' && surfaceIncludes('physical_ai');

/** Orca (agents). Off unless the build turns it on. */
export const agentsModuleEnabled =
  import.meta.env.VITE_AGENTS_MODULE_ENABLED === 'true' && surfaceIncludes('agents');

export function canAccessAgents(
  user: { role?: string; products?: { agents?: boolean } } | null | undefined,
  enabled = agentsModuleEnabled,
): boolean {
  if (!enabled || !user) return false;
  if (user.role === 'super_admin') return true;
  return ['admin', 'project_manager'].includes(user.role || '') && user.products?.agents === true;
}

export function canAccessPhysicalAi(
  user: { role?: string; products?: { physical_ai?: boolean } } | null | undefined,
  enabled = physicalAiModuleEnabled,
): boolean {
  // PM/annotator access will be added with project-scoped assignments, not tenant-wide access.
  return enabled && (user?.role === 'super_admin' || (user?.role === 'admin' && user.products?.physical_ai === true));
}

export function canAccessAppBench(
  user: { role?: string; products?: { appbench?: boolean } } | null | undefined,
  moduleEnabled = appBenchModuleEnabled,
): boolean {
  return moduleEnabled && (user?.role === 'super_admin' || user?.products?.appbench === true);
}
